/**
 * CZNA-1588 — how an organization reads in the users list: its column and its filter.
 */
import { OrganizationStatusEnum } from "../types/api";
/** "SIGLA – Name"; the name alone when the organization has no sigla. */
export var formatOrganizationLabel = function (sigla, name) {
    if (!name)
        return sigla !== null && sigla !== void 0 ? sigla : "";
    return sigla ? "".concat(sigla, " \u2013 ").concat(name) : name;
};
/**
 * Options of the organization filter: "all organizations" first, then the organizations in
 * the order given, archived ones marked. A selected id no organization matches (it came
 * from the URL and the organization is gone) stays listed, so the filter it applies is
 * visible and can be changed rather than narrowing the list invisibly.
 *
 * That "unknown" option is offered only once the organizations have `loaded`: before
 * that every id is unmatched, and the stripes Selection keeps the option it matched on
 * mount — a cold reload would show "unknown organization" for good.
 */
export var buildOrganizationFilterOptions = function (organizations, intl, selectedId, loaded) {
    var options = [
        {
            value: "",
            label: intl.formatMessage({
                id: "ui-czna-users.users.filter.organization.all",
            }),
        },
    ];
    organizations.forEach(function (organization) {
        if (!organization.id)
            return;
        var label = formatOrganizationLabel(organization.sigla, organization.name);
        options.push({
            value: organization.id,
            label: organization.status === OrganizationStatusEnum.INACTIVE
                ? intl.formatMessage({ id: "ui-czna-users.users.filter.organization.archived" }, { label: label })
                : label,
        });
    });
    if (loaded &&
        selectedId &&
        !options.some(function (option) { return option.value === selectedId; })) {
        options.push({
            value: selectedId,
            label: intl.formatMessage({
                id: "ui-czna-users.users.filter.organization.unknown",
            }),
        });
    }
    return options;
};
var normalize = function (value) {
    return value.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
};
/**
 * Filter for the stripes `Selection`: matches the term anywhere in the label, ignoring
 * letter case and diacritics. The stripes default matches only the START of the label, so
 * "zemská" would never find "BOA001 – Moravská zemská knihovna", and it reads the term as
 * a regular expression.
 */
export var filterOrganizationOptions = function (term, options) {
    var needle = normalize(term.trim());
    if (!needle)
        return options;
    return options.filter(function (option) { return normalize(option.label).includes(needle); });
};
